import BadgeTemplate from '../../html/components/badge.html'

import Component from '../shared/component'

export const Badge = Component('v-badge', {
  template: BadgeTemplate,
  props: {
    size: {
      type: String,
      default: null,
      validator (value) {
        switch (value) {
          case '':
          case 'large':
            return true
          default:
            return false
        }
      }
    },
    color: {
      type: String,
      default: null,
      validator (value) {
        switch (value) {
          case '':
          case 'green':
            return true
          default:
            return false
        }
      }
    }
  },
  computed: {
    classes () {
      return {
        [`is-${this.size}`]: this.size,
        [`is-${this.color}`]: this.color
      }
    }
  }
})
